module.exports = __webpack_public_path__ + "img/karta-mundurowa.98fb3921.svg";